import TheSideBar from "../components/common/TheSideBar"
import TheHeader from "../components/common/TheHeader"
import { Outlet, useLocation } from "react-router-dom";
import TheFooter from "../components/common/TheFooter"
import { useState, useEffect } from "react";

const TheLayout = () => {
    // Desktop: true = full 270px, false = collapsed 80px
    const [desktopExpanded, setDesktopExpanded] = useState<boolean>(true);
    // Mobile: true = drawer open with backdrop, false = closed off-screen
    const [mobileOpen, setMobileOpen] = useState<boolean>(false);
    const location = useLocation();

    // Auto-close mobile drawer when route changes
    useEffect(() => {
        setMobileOpen(false);
    }, [location.pathname]);

    // Close mobile drawer when window resizes to desktop size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setMobileOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleToggle = () => {
        if (window.innerWidth < 1024) {
            setMobileOpen(prev => !prev);
        } else {
            setDesktopExpanded(prev => !prev);
        }
    };

    const closeMobile = () => {
        setMobileOpen(false);
    };

    return (
        <div className="min-h-screen bg-slate-50 relative flex flex-col">
            {/****************** Mobile Backdrop Overlay *******************/}
            {mobileOpen && (
                <div
                    className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-40 lg:hidden transition-opacity cursor-pointer"
                    onClick={closeMobile}
                    aria-label="Close sidebar overlay"
                />
            )}

            {/****************** SideBar (Managed purely with Tailwind) *******************/}
            <aside
                className={`fixed top-0 bottom-0 left-0 z-50 lg:z-30 h-full bg-white border-r border-slate-100 transition-all duration-300 ease-in-out overflow-y-auto ${
                    mobileOpen
                        ? 'translate-x-0 w-[290px] shadow-2xl'
                        : '-translate-x-full lg:translate-x-0'
                } ${
                    desktopExpanded
                        ? 'lg:w-[270px]'
                        : 'lg:w-[80px]'
                }`}
            >
                <TheSideBar
                    handled={mobileOpen || desktopExpanded}
                    onClose={closeMobile}
                    isMobile={mobileOpen}
                />
            </aside>

            {/****************** Main Area (Managed purely with Tailwind) *******************/}
            <main
                className={`flex-1 flex flex-col min-h-screen transition-all duration-300 ease-in-out w-full ml-0 ${
                    desktopExpanded
                        ? 'lg:ml-[270px] lg:w-[calc(100%-270px)]'
                        : 'lg:ml-[80px] lg:w-[calc(100%-80px)]'
                }`}
            >
                {/****************** Header *******************/}
                <TheHeader onToggleSidebar={handleToggle} changeDiv={setDesktopExpanded} />

                {/****************** Pages *******************/}
                <div className="flex-1">
                    <Outlet />
                </div>

                {/****************** Footer *******************/}
                <footer className="mt-auto">
                    <TheFooter />
                </footer>
            </main>
        </div>
    );
};

export default TheLayout